"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _router = _interopRequireDefault(require("@/router"));
var _helpers = require("@/helpers");
var _underLoading = require("../helpers/under-loading");
var _stock = _interopRequireDefault(require("@/services/stock.service"));
var _utils = require("@/utils");
var MutationTypes = _interopRequireWildcard(require("../mutation-types"));
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t0 in e) "default" !== _t0 && {}.hasOwnProperty.call(e, _t0) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t0)) && (i.get || i.set) ? o(f, _t0, i) : f[_t0] = e[_t0]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var state = {
  inventory: []
};
var mutations = _defineProperty({}, MutationTypes.SET_INVENTORY, function (state, _ref) {
  var payload = _ref.payload;
  state.inventory = payload;
});
var getters = {
  inventory: function inventory(state) {
    return state.inventory;
  }
};
var actions = {
  // eslint-disable-no-trailing-spaces
  fetchInventoryStorage: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref2, payload) {
      var commit, rootState, farmID, _yield$stockService$f, data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref2.commit, rootState = _ref2.rootState;
            _context.p = 1;
            farmID = rootState.farm.farm.id;
            _context.n = 2;
            return _stock.default.fetchInventoryStorage(farmID);
          case 2:
            _yield$stockService$f = _context.v;
            data = _yield$stockService$f.data;
            return _context.a(2, data);
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.log('error: ', _t);
            _helpers.errorResponseHelper.display(_t);
            return _context.a(2, false);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }()),
  // eslint-disable-no-trailing-spaces
  fetchInventory: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref4, payload) {
      var commit, rootState, farmID, response, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            commit = _ref4.commit, rootState = _ref4.rootState;
            _context2.p = 1;
            farmID = rootState.farm.farm.id;
            _context2.n = 2;
            return _stock.default.fetchInventory(farmID);
          case 2:
            response = _context2.v;
            commit(MutationTypes.SET_INVENTORY, {
              payload: response.data
            });
            return _context2.a(2, response);
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            console.log('error: ', _t2);
            _helpers.errorResponseHelper.display(_t2);
            return _context2.a(2, false);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }()),
  createInventory: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref6, payload) {
      var commit, rootState, farmID, payloadData, err, response, successMessage, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            commit = _ref6.commit, rootState = _ref6.rootState;
            _context3.p = 1;
            farmID = rootState.farm.farm.id;
            payloadData = {
              name: payload.name,
              description: payload.description,
              type: payload.type,
              supplier: payload.supplier,
              quantity: payload.quantity,
              measurementType: payload.measurementType
            };
            if (payload.cost) {
              payloadData.cost = payload.cost;
            }
            if (payload.purchaseDate) {
              payloadData.purchaseDate = (0, _utils.convertDateISO)(payload.purchaseDate);
            }
            if (payload.arrivalDate) {
              payloadData.arrivalDate = (0, _utils.convertDateISO)(payload.arrivalDate);
            }
            if (farmID) {
              _context3.n = 2;
              break;
            }
            err = {
              response: {
                data: {
                  message: 'farmid_not_found'
                }
              }
            };
            throw err;
          case 2:
            _context3.n = 3;
            return _stock.default.createInventory(farmID, payloadData);
          case 3:
            response = _context3.v;
            successMessage = _router.default.app.$t('pages.stock.messages.create_success');
            _helpers.messageHelper.success(successMessage);
            return _context3.a(2, response);
          case 4:
            _context3.p = 4;
            _t3 = _context3.v;
            _helpers.errorResponseHelper.display(_t3);
            return _context3.a(2, false);
        }
      }, _callee3, null, [[1, 4]]);
    }));
    return function (_x5, _x6) {
      return _ref7.apply(this, arguments);
    };
  }()),
  fetchDetailInventory: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref8, id) {
      var commit, rootState, response, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            commit = _ref8.commit, rootState = _ref8.rootState;
            _context4.p = 1;
            _context4.n = 2;
            return _stock.default.fetchDetailInventory(id);
          case 2:
            response = _context4.v;
            return _context4.a(2, response);
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            _helpers.errorResponseHelper.display(_t4);
            return _context4.a(2, false);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return function (_x7, _x8) {
      return _ref9.apply(this, arguments);
    };
  }()),
  updateInventory: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref0, payload) {
      var commit, rootState, idInventory, data, response, successMessage, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref0.commit, rootState = _ref0.rootState;
            _context5.p = 1;
            idInventory = payload.id;
            data = _lodash.default.cloneDeep(payload.data);
            delete data.id;
            delete data.updatedAt;
            delete data.createdAt;
            if (data.purchaseDate) {
              data.purchaseDate = (0, _utils.convertDateISO)(data.purchaseDate);
            }
            if (data.arrivalDate) {
              data.arrivalDate = (0, _utils.convertDateISO)(data.arrivalDate);
            }
            _context5.n = 2;
            return _stock.default.updateInventory(idInventory, data);
          case 2:
            response = _context5.v;
            successMessage = _router.default.app.$t('pages.stock.messages.update_success');
            _helpers.messageHelper.success(successMessage);
            return _context5.a(2, response);
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            _helpers.errorResponseHelper.display(_t5);
            return _context5.a(2, false);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return function (_x9, _x0) {
      return _ref1.apply(this, arguments);
    };
  }()),
  checkOutProduct: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(_ref10, payload) {
      var commit, rootState, idInventory, data, response, successMessage, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            commit = _ref10.commit, rootState = _ref10.rootState;
            _context6.p = 1;
            idInventory = payload.id;
            data = payload.data;
            _context6.n = 2;
            return _stock.default.checkOutProduct(idInventory, data);
          case 2:
            response = _context6.v;
            successMessage = _router.default.app.$t('pages.stock.messages.exit_success');
            _helpers.messageHelper.success(successMessage);
            return _context6.a(2, response);
          case 3:
            _context6.p = 3;
            _t6 = _context6.v;
            _helpers.errorResponseHelper.display(_t6);
            return _context6.a(2, false);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function (_x1, _x10) {
      return _ref11.apply(this, arguments);
    };
  }()),
  checkInProduct: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref12, payload) {
      var commit, rootState, idInventory, data, response, successMessage, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            commit = _ref12.commit, rootState = _ref12.rootState;
            _context7.p = 1;
            idInventory = payload.id;
            data = payload.data;
            _context7.n = 2;
            return _stock.default.checkInProduct(idInventory, data);
          case 2:
            response = _context7.v;
            successMessage = _router.default.app.$t('pages.stock.messages.entry_success');
            _helpers.messageHelper.success(successMessage);
            return _context7.a(2, response);
          case 3:
            _context7.p = 3;
            _t7 = _context7.v;
            _helpers.errorResponseHelper.display(_t7);
            return _context7.a(2, false);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return function (_x11, _x12) {
      return _ref13.apply(this, arguments);
    };
  }()),
  fetchLogInventory: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref14, id) {
      var commit, rootState, response, _t8;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            commit = _ref14.commit, rootState = _ref14.rootState;
            _context8.p = 1;
            _context8.n = 2;
            return _stock.default.fetchLogInventory(id);
          case 2:
            response = _context8.v;
            return _context8.a(2, response);
          case 3:
            _context8.p = 3;
            _t8 = _context8.v;
            _helpers.errorResponseHelper.display(_t8);
            return _context8.a(2, false);
        }
      }, _callee8, null, [[1, 3]]);
    }));
    return function (_x13, _x14) {
      return _ref15.apply(this, arguments);
    };
  }()),
  deleteInventory: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(_ref16, id) {
      var commit, rootState, response, successMessage, _t9;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            commit = _ref16.commit, rootState = _ref16.rootState;
            _context9.p = 1;
            _context9.n = 2;
            return _stock.default.deleteInventory(id);
          case 2:
            response = _context9.v;
            successMessage = _router.default.app.$t('pages.stock.messages.delete_success');
            _helpers.messageHelper.success(successMessage);
            return _context9.a(2, response);
          case 3:
            _context9.p = 3;
            _t9 = _context9.v;
            _helpers.errorResponseHelper.display(_t9);
            return _context9.a(2, false);
        }
      }, _callee9, null, [[1, 3]]);
    }));
    return function (_x15, _x16) {
      return _ref17.apply(this, arguments);
    };
  }())
};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};